export default __webpack_public_path__ + "static/media/leg-left-side.8c3d6f72.png";